/**
 Author - Suyash Chandra
 Git - https://bitbucket.org/SuyashChandra/
 **/

import React from "react";
import styled from "styled-components";

import {
  PrimaryText,
  SecondaryText
} from "components/Text";
import {WealthyEnv} from "helpers";

const ContactUs = () => {
  return (
     <>
       <ContactUsWrapper>
         <ContactUsContainer>
           <Title>
             Contact Us
           </Title>
           <ContactInfoContainer>
             <ContactDetails>
               <Row>
                 <SecondaryText additionalStyles="margin-bottom: 2rem">
                   We’d love to hear from you!
                 </SecondaryText>
               </Row>
               <Row>
                 For support related queries write to:
                 <Email>
                   customer.support@wealthy.in
                 </Email>
               </Row>
               <Row>
                 For business and hiring queries write to:
                 <Email>
                   hello@wealthy.in
                 </Email>
               </Row>
               <Row>
                 or Call us on:
                 <PhoneNumber>
                   +91 95382 00 111
                 </PhoneNumber>
               </Row>
               <Row>
                 <Timing>
                   Monday to Friday: 9am to 7pm
                 </Timing>
                 <Timing>
                   Saturday: 10am-5pm
                 </Timing>
               </Row>
             </ContactDetails>
             <AddressDetails>
               <SecondaryText>
                 Office Address
               </SecondaryText>
               <WealthyLocation id="wealthyLocation">
                 <GoogleMapIframe
                   allowFullScreen
                   style={{ border: 0 }}
                   id="google-map-iframe"
                   title="Wealthy office location map"
                   src={WealthyEnv.WEALTHY_GOOGLE_MAP_LINK}
                 />
               </WealthyLocation>
               <Text>
                 Wealthy.in
               </Text>
               <Text>
                 3rd Floor, Block B, No. 55/10, Harlukunte Village Sector 2 HSR Layout, Bengaluru, Karnataka 560102
               </Text>
             </AddressDetails>
           </ContactInfoContainer>
         </ContactUsContainer>
       </ContactUsWrapper>
     </>
  );
};

const Title = styled.h2`
   font-size: 4.5rem;
   color: #193176;
   text-align: center;
   line-height: 1.4;

   @media (max-width: 768px) {
     font-size: 3.5rem;
   }
 `;

const Text = styled(PrimaryText)`
   color: #333;
 `;

const ContactUsWrapper = styled.div`
   padding: 4rem 8rem 8rem;

   @media (max-width: 1200px) {
     padding: 8rem 6rem;
   }

   @media (max-width: 1070px) {
     padding: 8rem 4rem;
   }

   @media (max-width: 500px) {
     padding: 8rem 2rem;
   }
 `;

const ContactUsContainer = styled.div`
   width: 70%;
   margin: 0 auto;

   @media (max-width: 768px) {
     width: 90%;
   }
 `;

const ContactInfoContainer = styled.div`
   display: flex;
   justify-content: space-between;
   margin-top: 5rem;

   @media (max-width: 768px) {
     flex-direction: column;
   }
 `;

const ContactDetails = styled.div`
   width: 40%;

   @media (max-width: 768px) {
     width: 100%;
   }
 `;

const AddressDetails = styled.div`
   width: 40%;

   @media (max-width: 768px) {
     width: 100%;
     margin-top: 5rem;
   }
 `;

const Row = styled.div`
   font-family: Avenir-Book;
   font-size: 1.6rem;
 `;

const Email = styled.p`
   color: #2196f3;
   margin-bottom: 2rem;
 `;

const PhoneNumber = styled.p`
   color: rgba(0,0,0,0.8);
   font-family: Avenir-Heavy;
   font-size: 1.6rem;
 `;

const Timing = styled.span`
   font-size: 1.2rem;
   color: #666;
   display: block;
 `;

const WealthyLocation = styled.div`
   margin-top: 2rem;
 `;

const GoogleMapIframe = styled.iframe`
   width: 100%;
   height: 100%;
 `;

export default ContactUs;

